module.exports = __webpack_public_path__ + "img/equipos-de-sala-img-1.3e28e6af.jpg";